module.exports = __webpack_public_path__ + "static/media/documentCase.68842f9e.svg";